import store from "../store"
import { FULL_SIZE_LOADING } from "../store/data/actionTypes"

export const viewLoading = (state) => {
  store.dispatch({
    type: FULL_SIZE_LOADING,
    payload: state
  })
}
